import React from 'react';
import ImageLoader, { ImageLoaderProps } from './ImageLoader';

interface ImageProps extends ImageLoaderProps {}

export const Image = React.forwardRef<HTMLImageElement, ImageProps>(
  (
    {
      src = undefined,
      background = undefined,
      fallback = undefined,
      alt = undefined,
      placeholder = undefined,
      dimensions = undefined,
      fullSize = false,
      floatingEffect = false,
      className = undefined
    }: ImageProps,
    ref
  ) => {
    return (
      <ImageLoader
        ref={ref}
        src={src}
        fallback={fallback}
        alt={alt || 'no alt text provided'}
        background={background}
        peekUrl={placeholder}
        dimensions={dimensions}
        fullSize={fullSize}
        floatingEffect={floatingEffect}
        className={className}
      />
    );
  }
);

export default Image;
